import React from "react";
import "./AccountDeletion.css";

const AccountDeletion = () => {
  return (
    <div className="account-deletion">

      <h1>Account & Data Deletion – Armor</h1>

      <p>
        This page is for users of the <strong>Armor</strong> Android application
        developed and published by <strong>Red Wolf Info Tech</strong>.
      </p>

      <hr />

      <h2>How to Request Account & Data Deletion</h2>

      <p>
        If you have created an account in the Armor app and would like to delete
        your account and associated personal data, please submit a deletion
        request using the form below.
      </p>

      <p>
        Once we receive your request, we will verify the information and
        permanently delete your account and related data within a reasonable
        timeframe, in accordance with applicable laws and Google Play policies.
      </p>

      <hr />

      <h2>Data That Will Be Deleted</h2>
      <ul>
        <li>User account information</li>
        <li>App-related usage data associated with your account</li>
        <li>Any personal data stored on our servers</li>
      </ul>

      <p>
        Some non-personal or legally required data (if any) may be retained as
        required by law.
      </p>

      <hr />

      <h2>Submit Deletion Request</h2>

      <form>
        <label>
          Registered Email Address:
          <input type="email" name="email" required />
        </label>

        <label>
          Reason for Deletion (optional):
          <textarea name="reason" rows="4"></textarea>
        </label>

        <button type="submit">Submit Deletion Request</button>
      </form>

      <hr />

      <h2>Contact</h2>
      <p>
        If you have questions regarding account or data deletion, you may contact
        us at:
      </p>

      <p>
        <strong>Email:</strong> info@redwolfinfotech.com <br />
        <strong>Developer:</strong> Red Wolf Info Tech
      </p>

    </div>
  );
};

export default AccountDeletion;
